import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { JssTreeString } from '../../model/jss-tree-string';
import { FormArray } from '@angular/forms/src/model';

@Component({
   selector: 'app-mat-string',
   templateUrl: './string.component.html',
   styleUrls: ['./string.component.scss']
})
export class StringComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title = '';
   public _formControl: FormControl = null;
   public _formParent: FormGroup | FormArray = null;

   @Input() jssTreeLeaf: JssTreeString;
   @Input() readonly = false;

   constructor() { }

   ngOnInit() {

   }

   ngOnChanges() {
      if (this.jssTreeLeaf && !this.jssTreeLeaf.valuePassThrough) {
         this._nodeName = this.jssTreeLeaf.nodeName;
         this._nodeType = this.jssTreeLeaf.nodeType;
         this._formControl = this.jssTreeLeaf.getFormControl();
         this._formParent = this.jssTreeLeaf.getFormControlParent();

         // title
         if (this.jssTreeLeaf.showTitle) {
            this._title = this.jssTreeLeaf.hasTitle() ? this.jssTreeLeaf.title : this._nodeName;
         }

         // watch changes
         this._formControl.valueChanges.subscribe(val => {
            this.jssTreeLeaf.valueChanged(val);
         });
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/string/string.component.ts